import { Injectable } from '@angular/core';
import { LoggingService } from '@shared/logging';
import { RxCollectionCreator, RxJsonSchema } from 'rxdb';
import { MigrationStep } from './migration-step.interface';
import { MigrationV1 } from './migration-versions/migration-v1';
import { MigrationV2 } from './migration-versions/migration-v2';
import { MigrationV3 } from './migration-versions/migration-v3';

@Injectable()
export class MigrationManagerService {
	public static currentDatabaseVersion = 3;
	private initialMigration: MigrationStep;
	public constructor(private loggingService: LoggingService) {
		this.initialMigration = new MigrationV1(loggingService);
		const migrationV2 = new MigrationV2(loggingService);
		this.initialMigration.setNextVersion(migrationV2);
		migrationV2.setNextVersion(new MigrationV3(loggingService));
	}

	public applyMigration(schemaToMigrate: RxJsonSchema<any>): RxCollectionCreator {
		this.loggingService.info('MigrationManagerService', 'applyMigration');

		// since we generate schemas dynamically all the new imports will use CurrentDatabaseVersion as their version
		// since version is !=0 we have to provice a migration strategy but we set autoMigrate to false and we never apply that migration
		const migrationStrategy = {};
		const defaultCollection: RxCollectionCreator = {
			schema: schemaToMigrate,
			autoMigrate: false,
			migrationStrategies: migrationStrategy
		};

		const collection = this.initialMigration.applyMigrationOnSchema(defaultCollection);

		return collection;
	}
}
